export const isPageAction = <T>(action: T): action is T & { page: number } =>
  action &&
  typeof action === "object" &&
  "page" in action &&
  typeof action.page === "number";
